import React, { useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from "react-router";
import { ERROR_PAGE } from "../../../utils/AEMUrls";
import { configuredAEMUrl, getPageUrl, handleURLNavigationAEM, redirectTo, addFooterAndHeader } from "../../../utils/AEMUtils";
import {saveToRecentSearch} from "../../../modules/search/slice/typeaheadSlice"
import axios from "axios";

//import HeaderData from "./headerMockJsonData.json";


const HeaderContainer = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const { customerProfile,locale } = useSelector(state => state.CommonReducer);
    const { REACT_APP_SERVICE_URL, REACT_PAGERULES, DATA_ENABLECACHING, REACT_APP_BASEURL } = window.weeksWebCloudConfig;
    const userDetails = { ...customerProfile, memberId: customerProfile.subscriberId };
    const url = configuredAEMUrl(getPageUrl('/content/panorama/rci/post-wow/@@Country/@@Lang/header.model.json', locale));
    // console.log('Header',url);
    if(window.location.href.indexOf('?testHarness=true') > -1){
        localStorage.removeItem('_customerDetails');
        localStorage.removeItem('_userDetails');
        localStorage.removeItem('loginFormMessage');
    }
    let dataMatch = ' ';
    if(DATA_ENABLECACHING){
    const localStoredData = JSON.parse(localStorage.getItem('_customerDetails'));
      if(JSON.stringify(localStoredData) !== JSON.stringify(userDetails)){
        dataMatch = false;   
      }
      else{
        dataMatch = true;  
      }
    }
    localStorage.setItem('_customerDetails', JSON.stringify(userDetails));
    localStorage.setItem('_userDetails', JSON.stringify(userDetails));

    const handleURLNavigationToNewSearchPage = async (resultElement, productType, history, navigatedFrom) => {
        const urlTo = await redirectTo(resultElement, navigatedFrom);
        const finalURL = urlTo?.url || '';
        let refId = resultElement.referenceId || '';
        if(urlTo?.type === 'aimsresort'){
            refId = '';
        }
        const url = urlTo.url || '';
        const urlParams = new URLSearchParams(url.split('?')[1] || '');
        const lat = urlParams.get('lat');
        const lon = urlParams.get('long');
        if(urlTo?.type.toLowerCase() === 'geocode'){
            // ✅ Store coordinates in variables for further use
            if (lat && lon) {
                const latitude = parseFloat(lat);
                const longitude = parseFloat(lon);
                await dispatch(saveToRecentSearch({
                    ...resultElement,
                    latitude: latitude,
                    longitude: longitude
                }));
            }
        }
        const separator = finalURL.includes('?') ? '&' : '?';
        const searchUrl = `/pan-weeks-dashboard/${productType}${finalURL}${refId ? `${separator}refId=${encodeURIComponent(refId)}` : ''}`;
        // const searchUrl = `/pan-weeks-dashboard/${productType}${finalURL}&refId=${refId}`;
        // const searchUrl = `/pan-weeks-dashboard/${productType}${finalURL}`;

        window.location.href = searchUrl;
    }
    const handleNavigationFromHeader = async (event, isModified = false) => {
        if (event.detail.type === 'naviagetionEvent') {
            handleURLNavigationAEM(event.detail.url, history);
        }else if(event.detail.type === 'selectedSuggestion'){
            await handleURLNavigationToNewSearchPage(event.detail.payload,event.detail.productType, history, 'dashboard');
    }
    }

useEffect(() => {
        // console.log('AEM Header');
        document.removeEventListener('headerEvent', handleNavigationFromHeader);
        document.addEventListener('headerEvent', (event) => handleNavigationFromHeader(event));
        // deposit controller call fix for INC2241420/PWE-2277
        axios({url:`${REACT_APP_BASEURL}/weeks-account/dashboard-deposit?call=async`, method:"GET",params:{ajax:true}});
    }, []);

    return (<header-component
        isReact
        showtypeahead
        data-displaycacheddata={dataMatch}
        data-enablecaching={DATA_ENABLECACHING}
        data-userdetails={JSON.stringify(userDetails)}
        data-envdomain={REACT_APP_SERVICE_URL}
        data-applicationtype="WOW"
        data-url={url}
        data-errorurl={getPageUrl(ERROR_PAGE, locale)}
        data-apiurl={REACT_PAGERULES}
    />);
}


export default HeaderContainer;